import { DefaultService } from '@/services/default'

export class DisclaimerService extends DefaultService {
  static resourceURL = 'disclaimer/'
}

export class DisclaimerTemplateService extends DefaultService {
  static resourceURL = 'disclaimer-template/'
}
